import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import TakeOrderNew from './pages/TakeOrderNew.js';
import ListOrders from './pages/ListOrders.js';
import Payment from './pages/Payment.js';
import Home from './pages/Home.js';
import Login from './pages/Login.js';
import Admin from './pages/Admin.js';
import { CookiesProvider, useCookies } from 'react-cookie'

function App() {
  const [cookies, setCookie] = useCookies(['user'])

  function handleLogin(user) {
    setCookie('userRole', user.role, { path: '/' })
  }

  return (
    <div className="App">
      <CookiesProvider defaultSetOptions={{ path: '/' }}>
        <Router>
          <Routes>
            <Route path='/takeorder' element={<TakeOrderNew />} />
            <Route path='/orders' element={<ListOrders />} />
            <Route path='/payment' element={<Payment />} />
            {/* {
              !cookies.user ? <Route path='/' element={<Login onLogin={handleLogin}/>} /> : <Route path='/' element={<Home user={cookies.user} />} />
            } */}
            <Route path='/' element={<Login onLogin={handleLogin}/>} />
            <Route path='/home' element={<Home />} />
            <Route path='/admin' element={<Admin />} />
          </Routes>
        </Router>
      </CookiesProvider>
    </div>
  );
}

export default App;
